@if (isMasqueraded) {
    <div class="masquerade-header {{ topMarginClass }}">
        <div class="flex items-center">
            <img
                src="assets/svg/masquerade_dark.svg"
                alt="Masquerade Dark"
                class="w-5 h-5 mr-3"
            />
            <span class="text-error-800">
                Masquerading as: {{ firstName }} {{ lastName }}
            </span>
        </div>
        <button
            class="!rounded-lg !bg-error-700 !text-tertiary-50 !h-[25px]"
            type="button"
            color="primary"
            (click)="stopMasquerading()"
            mat-stroked-button
            title="End Masquerade"
        >
            End Masquerade
        </button>
    </div>
}
